import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["endSlot", "Heading", "responsive", "startSlot", "titleText"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import AbstractToolbar from './AbstractToolbar';
import H1 from '../elements/headings/H1';
import { WEB_FONT_REGULAR_WEIGHT } from 'HubStyleTokens/misc';
import { BASE_SPACING_X, HEADING4, INPUT_DEFAULT_HEIGHT, LAYOUT_EDITOR_PADDING, TOOLBAR_HEIGHT_DARK, BACK_BUTTON_ARROW_SIZE } from 'HubStyleTokens/sizes';
import { TOOLBAR_DARK_BACKGROUND_COLOR, TOOLBAR_DARK_FOREGROUND_COLOR } from 'HubStyleTokens/theme';
import { setFontSmoothing, toPx } from '../utils/Styles';

/** @internal */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const COMPUTED_PADDING_LEFT = toPx(parseInt(LAYOUT_EDITOR_PADDING, 10) + parseInt(BASE_SPACING_X, 10));
const EditorToolbar = styled(AbstractToolbar).withConfig({
  displayName: "UIEditorToolbar__EditorToolbar",
  componentId: "sc-1efbr9w-0"
})(["background:", ";color:", ";padding-left:", ";padding-right:", ";&&&{.private-back-button{vertical-align:bottom;}.private-back-button > *{text-decoration:none;vertical-align:inherit;}.private-breadcrumbs__arrow--back{font-size:", ";margin-right:0;}}"], TOOLBAR_DARK_BACKGROUND_COLOR, TOOLBAR_DARK_FOREGROUND_COLOR, COMPUTED_PADDING_LEFT, LAYOUT_EDITOR_PADDING, BACK_BUTTON_ARROW_SIZE);
const EditorHeading = styled(H1).withConfig({
  displayName: "UIEditorToolbar__EditorHeading",
  componentId: "sc-1efbr9w-1"
})(["font-size:", ";", ";font-weight:", ";margin-bottom:0;margin:-5px;padding:5px;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"], HEADING4, setFontSmoothing('auto'), WEB_FONT_REGULAR_WEIGHT);
const COMPUTED_SLOT_PADDING = (parseInt(TOOLBAR_HEIGHT_DARK, 10) - parseInt(INPUT_DEFAULT_HEIGHT, 10)) / 2;
const EditorInner = styled(AbstractToolbar.defaultProps.Inner).withConfig({
  displayName: "UIEditorToolbar__EditorInner",
  componentId: "sc-1efbr9w-2"
})(["min-height:", ";> *{padding:", " 0;}"], TOOLBAR_HEIGHT_DARK, toPx(COMPUTED_SLOT_PADDING));
const EditorMiddle = styled(AbstractToolbar.defaultProps.Middle).withConfig({
  displayName: "UIEditorToolbar__EditorMiddle",
  componentId: "sc-1efbr9w-3"
})(["flex-basis:auto;flex-grow:1;min-width:0;"]);
const RenderHeading = ({
  Heading,
  titleText
}) => {
  const Element = Heading;
  return /*#__PURE__*/_jsx(Element, {
    "aria-level": 1,
    children: titleText
  });
};
const UIEditorToolbar = props => {
  const {
      endSlot,
      Heading = EditorHeading,
      responsive = false,
      startSlot,
      titleText
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);

  // the only time you should set startSlot to fragment is if there is an endSlot and no startSlot
  const computedStartSlot = !startSlot && titleText && endSlot ? /*#__PURE__*/_jsx(_Fragment, {}) : startSlot;
  const computedEndSlot = !endSlot && titleText && startSlot ? /*#__PURE__*/_jsx(_Fragment, {}) : endSlot;
  return /*#__PURE__*/_jsx(EditorToolbar, Object.assign({}, rest, {
    __distributeEvenly: true,
    endSlot: computedEndSlot,
    Inner: EditorInner,
    Middle: EditorMiddle,
    middleSlot: RenderHeading({
      Heading,
      titleText
    }),
    responsive: responsive,
    startSlot: computedStartSlot
  }));
};
UIEditorToolbar.propTypes = {
  endSlot: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  Heading: PropTypes.elementType,
  responsive: PropTypes.bool.isRequired,
  startSlot: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  titleText: PropTypes.node
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIEditorToolbar.defaultProps = {
  Heading: EditorHeading,
  responsive: false
};
UIEditorToolbar.displayName = 'UIEditorToolbar';
export default UIEditorToolbar;